export default __webpack_public_path__ + "static/media/HomeDeactive.0e128d2a.svg";